var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    on: {
      "dragover": function dragover($event) {
        $event.preventDefault();
        return _vm.dragOver.apply(null, arguments);
      },
      "dragleave": function dragleave($event) {
        $event.preventDefault();
        return _vm.dragLeave.apply(null, arguments);
      },
      "drop": function drop($event) {
        $event.preventDefault();
        return _vm.onFileDrop($event);
      }
    }
  }, [_vm.isDrag ? _c('div', {
    staticClass: "drag fadeIn"
  }, [!_vm.isDrop ? _c('v-icon', {
    staticStyle: {
      "zoom": "3"
    },
    attrs: {
      "x-large": ""
    }
  }, [_vm._v("mdi-file")]) : _vm.isFailed ? _c('v-icon', {
    staticClass: "fade",
    staticStyle: {
      "zoom": "3"
    },
    attrs: {
      "x-large": "",
      "color": "error"
    }
  }, [_vm._v("mdi-close")]) : _c('v-icon', {
    staticClass: "fade",
    staticStyle: {
      "zoom": "3"
    },
    attrs: {
      "x-large": "",
      "color": "success"
    }
  }, [_vm._v("mdi-check-bold")])], 1) : _vm._e(), _c('paginated-table', {
    attrs: {
      "store": _vm.store,
      "headers": _vm.headers,
      "baseQuery": {
        partnerId: _vm.partnerId
      },
      "controlElements": _vm._controlElements,
      "predefinedFilter": _vm.predefinedFilter,
      "showSelect": false
    },
    on: {
      "click:row": _vm.setSelectedItem
    },
    scopedSlots: _vm._u([{
      key: "bodyActions",
      fn: function fn() {
        return [_c('Can', {
          attrs: {
            "I": _vm.ActionEnum.CREATE,
            "a": _vm.ResourceEnum.INVOICE,
            "field": _vm.partnerId
          }
        }, [_c('create-invoice-outbound-dialog', {
          ref: "createInvoiceOutboundDialog",
          staticClass: "mx-1",
          attrs: {
            "hideButton": false,
            "partnerId": _vm.partnerId,
            "reportId": _vm.reportId,
            "vehicleId": _vm.vehicleId,
            "fleetId": _vm.fleetId,
            "text": "enums.DocumentDirectionEnum.outbound"
          },
          on: {
            "created": _vm.setSelectedItem
          }
        })], 1), _c('Can', {
          attrs: {
            "I": _vm.ActionEnum.CREATE,
            "a": _vm.ResourceEnum.INVOICE,
            "field": _vm.partnerId
          }
        }, [_c('create-invoice-inbound-dialog', {
          ref: "createInvoiceInboundDialog",
          attrs: {
            "hideButton": false,
            "partnerId": _vm.partnerId,
            "reportId": _vm.reportId,
            "vehicleId": _vm.vehicleId,
            "fleetId": _vm.fleetId,
            "text": "enums.DocumentDirectionEnum.inbound"
          },
          on: {
            "created": _vm.setSelectedItem
          }
        })], 1), _vm._t("bodyActions")];
      },
      proxy: true
    }, {
      key: "item.status",
      fn: function fn(_ref) {
        var item = _ref.item;
        return [_c('v-chip', {
          attrs: {
            "color": item.statusColor,
            "small": "",
            "dark": ""
          }
        }, [_vm._v(_vm._s(_vm.$t("enums.InvoiceStatusEnum.".concat(item.status))))])];
      }
    }, {
      key: "item.direction",
      fn: function fn(_ref2) {
        var item = _ref2.item;
        return [_vm._v(" " + _vm._s(_vm.$t("enums.DocumentDirectionEnum.".concat(item.direction))) + " ")];
      }
    }, {
      key: "item.party",
      fn: function fn(_ref3) {
        var item = _ref3.item;
        return [_c('span', {
          staticClass: "text-truncate"
        }, [_vm._v(" " + _vm._s(item.direction === _vm.DocumentDirectionEnum.INBOUND ? item.seller.name : item.buyer.name) + " ")])];
      }
    }, {
      key: "item.number",
      fn: function fn(_ref4) {
        var item = _ref4.item;
        return [item.number ? _c('span', [_vm._v(_vm._s(item.number))]) : _c('span', [_vm._v(" " + _vm._s(_vm.$t("enums.InvoiceStatusEnum.draft")) + " ")])];
      }
    }, {
      key: "item.type",
      fn: function fn(_ref5) {
        var item = _ref5.item;
        return [_vm._v(" " + _vm._s(_vm.$t("enums.InvoiceTypeEnum.".concat(item.type))) + " ")];
      }
    }, {
      key: "item.date",
      fn: function fn(_ref6) {
        var item = _ref6.item;
        return [_vm._v(" " + _vm._s(_vm._f("simpleDate")(item.date)) + " ")];
      }
    }, {
      key: "item.due",
      fn: function fn(_ref7) {
        var item = _ref7.item;
        return [_c('due-date-chip', {
          attrs: {
            "ticket": item
          }
        })];
      }
    }, {
      key: "item.subTotal",
      fn: function fn(_ref8) {
        var item = _ref8.item;
        return [_vm._v(" " + _vm._s(_vm.formatCurrency(item.subTotal, item.currency)) + " ")];
      }
    }], null, true)
  }), _vm.selectedItem ? _c('invoice-side-card', {
    attrs: {
      "value": _vm.selectedItem
    },
    on: {
      "close": function close() {
        return _vm.setSelectedItem(null);
      }
    }
  }) : _vm._e(), _vm.isDeleteDialogActive && _vm.selectedItemForDelete ? _c('confirm-action-dialog', {
    attrs: {
      "isDialogActive": _vm.isDeleteDialogActive,
      "fullscreen": _vm.$vuetify.breakpoint.smAndDown,
      "title": _vm.$t('partner.PartnerReportDetailChangeProgress.confirmDeleteTitle'),
      "rightColor": 'error',
      "rightLoading": _vm.isDeleteLoading
    },
    on: {
      "update:isDialogActive": function updateIsDialogActive($event) {
        _vm.isDeleteDialogActive = $event;
      },
      "update:is-dialog-active": function updateIsDialogActive($event) {
        _vm.isDeleteDialogActive = $event;
      },
      "close": function close($event) {
        _vm.isDeleteDialogActive = false;
      },
      "leftClick": function leftClick($event) {
        _vm.isDeleteDialogActive = false;
      },
      "rightClick": _vm.onDelete
    }
  }, [_c('refs-invoice', {
    attrs: {
      "item": _vm.selectedItemForDelete
    }
  })], 1) : _vm._e()], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }